import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import StudentForm from "@/components/StudentForm";
import { ArrowLeft, UserPlus, CheckCircle } from "lucide-react";
import { toast, Toaster } from "sonner";
import { ACADEMY_NAME, LOGO_URL } from "@/lib/brand";

export default function StudentRegister() {
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(null);
  const navigate = useNavigate();

  const submit = async (payload) => {
    setSaving(true);
    try {
      const { data } = await api.post("/auth/student/register", payload);
      setDone(data);
      toast.success("Registration submitted");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to register");
    } finally {
      setSaving(false);
    }
  };

  if (done) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
        <div className="max-w-lg w-full bg-white border border-slate-200 rounded-lg p-8 text-center shadow-sm">
          <img src={LOGO_URL} alt="Uday Career Academy" className="w-20 h-20 object-contain mx-auto mb-4" />
          <CheckCircle size={48} className="text-emerald-600 mx-auto mb-3" />
          <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: "Chivo" }}>Registration Submitted!</h1>
          <p className="text-slate-600 mb-2">Your Student ID is:</p>
          <p className="text-2xl font-mono font-bold text-slate-900 mb-6">{done.student_id}</p>
          <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-md p-3 mb-6">
            {done.message}
          </p>
          <button onClick={() => navigate("/student-login")} className="text-sm font-semibold text-slate-900 hover:underline">
            Go to login →
          </button>
        </div>
        <Toaster position="top-right" richColors />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <button onClick={() => navigate("/login")} className="flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900" data-testid="back-from-register">
            <ArrowLeft size={16} /> Back
          </button>
          <div className="flex items-center gap-2">
            <img src={LOGO_URL} alt="logo" className="w-9 h-9 object-contain" />
            <span className="font-bold text-sm" style={{ fontFamily: "Chivo" }}>{ACADEMY_NAME}</span>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-10">
        <div className="mb-8">
          <div className="label-caps mb-2 flex items-center gap-2"><UserPlus size={12} /> New Registration</div>
          <h1 className="text-4xl font-bold tracking-tight" style={{ fontFamily: "Chivo" }}>Student Registration</h1>
          <p className="text-slate-500 mt-1">श्री उदय करीअर अकॅडमी — पोलीस आर्मी भरती स्पेशल</p>
        </div>
        <StudentForm onSubmit={submit} submitLabel="Submit Registration" isPublic saving={saving} />
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
}
